export default "__VITE_ASSET__NwwTR$UX__"